import { gql } from "@apollo/client"

export const CONTACTUS_FORM = gql`
mutation($comment: String!,$email: String!,$name: String!,$telephone: String!) {
  contactUs(
    input: {
      comment: $comment,
      email: $email,
      telephone: $telephone,
      name: $name 
      }
      ) {
    status
  }
}`;